import {FC, FocusEvent, useMemo} from 'react';
import {SelectChangeEvent} from '@mui/material';
import {useIntl} from 'react-intl';
import {employeeApi} from 'src/api';
import {EmployeeSortFieldEnum} from 'src/enums';
import {SelectValue} from 'src/types';
import {NO_EMPLOYEE_OPTION} from '../formData/rfid/rfid';
import {AMPFormSelect} from '../../common/AMPFormSelect';

interface CompanyEmployeeSelectProps {
    businessId?: number;
    companyId?: number;
    value: string;
    onChange?: (e: SelectChangeEvent<any>) => void;
    onBlur?: (e: FocusEvent<any>) => void;
    hasError?: boolean | string;
    helperText?: string;
}

export const CompanyEmployeeSelect: FC<CompanyEmployeeSelectProps> = ({
                                                                          businessId,
                                                                          companyId,
                                                                          value,
                                                                          onChange,
                                                                          onBlur,
                                                                          hasError,
                                                                          helperText,
                                                                      }) => {
    const intl = useIntl();

    const {data: employeesData} = employeeApi.useSearchEmployeesQuery({
        params: {
            page: 0,
            size: 100,
        },
        data: {
            keyword: '',
            businessId,
            companyId,
            sortAsc: true,
            sortField: EmployeeSortFieldEnum.EMAIL,
        },
    }, {
        skip: !companyId || !businessId,
    });

    const options: SelectValue[] = useMemo(() => {
        const employees = employeesData?.content ?? [];
        return [
            {
                value: NO_EMPLOYEE_OPTION,
                id: -1,
                name: intl.formatMessage({id: 'rfidNoEmployee'}),
            },
            ...employees.map((employee) => {
                const fullName = `${employee.firstName ?? ''} ${employee.lastName ?? ''}`.trim();
                return {
                    value: String(employee.id),
                    id: employee.id,
                    name: fullName || employee.user?.emailAddress || String(employee.id),
                };
            }),
        ];
    }, [employeesData, intl]);

    return (
        <AMPFormSelect
            data={options}
            value={value}
            label={'employee'}
            input={'employeeId'}
            onChange={onChange}
            onBlur={onBlur}
            hasError={hasError}
            helperText={helperText}
        />
    );
};
